<template>
  <div>
    <va-modal
      :value="showModal"
      id="createMeasurementModal"
      ref="createMeasurementModal"
      size="large"
      :showOkay="true"
      :okText="$t('people.actions.create')"
      :okDisabled="!canSubmit || isSubmiting"
      @cancel="$emit('cancel')"
      :cancelText="$t('leads.back')"
      @ok="(e) => handleSubmit(e)"
      :noDismiss="true"
      :no-outside-dismiss="false"
      :fixedLayout="true">
      <div slot="header" class="modal-title d-flex justify--space-between pb-0">
        <span>{{ $t('checkup_plus.person.measurements.new_measurement')}}</span>
      </div>

      <div>
        <div v-if="isSubmiting" class="loading-overlay">
          <SubmitingPlaceholder />
        </div>


        <form class="evollu-form">
          <div>
            <div class="col-12">
              <h5> {{ $t('checkup_plus.person.measurements.create.appointments.title') }}</h5>
            </div>
            <div class="row col-12 mt-3">
              <h6 style="margin-top: 0.1rem">{{this.$t('checkup_plus.person.measurements.create.appointments.create_or_associate')}}</h6>
              &ensp;
              &ensp;

            </div>
            <div>
              <div class="row">
                <div class="col-4">
                  <div class="form-group">
                    <div class="input-group">
                      <va-date-picker
                        class="w-100"
                        v-model="form.appointment.start"
                        :placeholder="$t('agenda.availability.start')"
                        :label="$t('agenda.availability.start')"
                        :config="{
                          defaultDate: moment().format('YYYY/MM/DD HH:mm'),
                          enableTime: true,
                          time_24hr: true,
                          minuteIncrement: 15,
                          dateFormat: 'Y/m/d H:i'}"
                        @input="() => {this.form.appointment.end = moment(this.form.appointment.start).add(30, 'minutes').format('YYYY/MM/DD HH:mm')}"
                      />
                      <i class="bar"></i>
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="form-group">
                    <div class="input-group">
                      <va-date-picker
                        class="w-100"
                        v-model="form.appointment.end"
                        :placeholder="$t('agenda.availability.end')"
                        :label="$t('agenda.availability.end')"
                        :config="{
                          enableTime: true,
                          time_24hr: true,
                          defaultDate: moment().add(30, 'minutes').format('YYYY/MM/DD HH:mm'),
                          minuteIncrement: 15,
                          dateFormat: 'Y/m/d H:i',
                    }"/>
                      <i class="bar"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <AppointmentsTable
                  v-if="form.appointment.start !== null && form.appointment.end !== null"
                  :selectedPatientId="patientDetails.idPerson"
                  :appointmentDates.sync="form.appointment"
                  @selectedAppointment="handleSelectedAppointment"
                />
                <div v-if="form.appointment.start && form.appointment.end">
                  <span class="is-bold" v-if="form.selectedAppointment"> {{this.$t('checkup_plus.person.measurements.create.appointments.messages.warning_associating', {from: moment(form.selectedAppointment.begin).format('YYYY-MM-DD HH:mm'), to: moment(form.selectedAppointment.end).format('YYYY-MM-DD HH:mm')})}} </span>
                  <span class="is-bold" v-else>{{this.$t('checkup_plus.person.measurements.create.appointments.messages.warning_creating', {from: form.appointment.start, to: form.appointment.end})}}</span>
                </div>
              </div>
            </div>
          </div>

          <va-separator style="height: 8px; border-radius: 25px"/>
          <div class="row">
            <div class="col-12">
              <label class="form-label">{{$t('checkup_plus.person.rules.rule_creation.measurement')}}</label>
              <multiselect
                v-model="form.measurementType"
                trackBy="id"
                label="translation"
                :options="measurementTypesOptions"
                :appendToBody="true"
                :multiple="false"
                :placeholder="$t('checkup_plus.person.rules.rule_creation.measurement')"
                :disabled="selectedMeasurementId !== null"
                @input="resetMeasurementObj"
              />
            </div>
          </div>



        <div v-if="form.appointment.start !== null && form.appointment.end !== null" class="mt-4">

          <!--<va-separator style="height: 8px; border-radius: 25px"/> -->
          <!-- Create  for Mapa 24 -->
          <div class="row" v-if="form.measurementType && form.measurementType.id === 20">
            <Mapa24XmlImporter :measurement.sync="measurement" :appointmentDates.sync="form.appointment"  @updateCanSubmit="(val) => {this.canSubmit = val}"/>
          </div>
          <!-- End create for Mapa 24 -->
          <!-- Create for BLOOD PRESSURE -->
          <div v-else-if="form.measurementType && form.measurementType.id === 2">
            <BloodPressureCreation :measurement.sync="measurement" :appointmentDates.sync="form.appointment" @updateCanSubmit="(val) => {this.canSubmit = val}"/>
          </div>
          <!-- End create for Blood Pressure -->
          <!-- Create for OXIMETRY -->
          <div v-else-if="form.measurementType && form.measurementType.id === 18">
            <OximetryCreation :measurement.sync="measurement" :appointmentDates.sync="form.appointment" @updateCanSubmit="(val) => {this.canSubmit = val}"/>
          </div>
          <!-- End create for OXIMETRY -->
          <!-- Create for GLUCOSE -->
          <div v-else-if="form.measurementType && form.measurementType.id === 4">
            <GlucoseCreation :measurement.sync="measurement" :appointmentDates.sync="form.appointment" @updateCanSubmit="(val) => {this.canSubmit = val}"/>
          </div>
          <!-- End create for GLUCOSE -->
          <!-- Create for SPIROMETRY -->
          <div v-else-if="form.measurementType && form.measurementType.id === 11">
            <SpirometryCreation :measurement.sync="measurement" :appointmentDates.sync="form.appointment" @updateCanSubmit="(val) => {this.canSubmit = val}"/>
          </div>
          <!-- End create for SPIROMETRY -->
          <!-- Create for TEMPERATURE -->
          <div v-else-if="form.measurementType && form.measurementType.id === 3">
            <TemperatureCreation :measurement.sync="measurement" :appointmentDates.sync="form.appointment" @updateCanSubmit="(val) => {this.canSubmit = val}"/>
          </div>
          <!-- End create for TEMPERATURE -->
          <!-- Create for BODY COMPOSITION -->
          <div v-else-if="form.measurementType && form.measurementType.id === 5">
            <BodyCompositionCreation :measurement.sync="measurement" :appointmentDates.sync="form.appointment" @updateCanSubmit="(val) => {this.canSubmit = val}"/>
          </div>
          <!-- End create for BODY COMPOSITION -->
          <!-- Create for CHOLESTEROL -->
          <div v-else-if="form.measurementType && form.measurementType.id === 10000">
            <CholesterolCreation :measurement.sync="measurement" :appointmentDates.sync="form.appointment" @updateCanSubmit="(val) => {this.canSubmit = val}"/>
          </div>
          <!-- End create for CHOLESTEROL -->


        </div>
      </form>
      </div>
    </va-modal>
  </div>

</template>

<script>
import Multiselect from 'vue-multiselect'
import Mapa24XmlImporter from "@/components/checkup_plus/patients/ParametersDetails/Mapa24/Mapa24XmlImporter.vue";
import {OneCareService} from "@/api/OneCareService";
import BloodPressureCreation
  from "@/components/checkup_plus/patients/ParametersDetails/MeasurementsCreation/BloodPressureCreation.vue";
import OximetryCreation
  from "@/components/checkup_plus/patients/ParametersDetails/MeasurementsCreation/OximetryCreation.vue";
import GlucoseCreation
  from "@/components/checkup_plus/patients/ParametersDetails/MeasurementsCreation/GlucoseCreation.vue";
import SpirometryCreation
  from "@/components/checkup_plus/patients/ParametersDetails/MeasurementsCreation/SpirometryCreation.vue";
import TemperatureCreation
  from "@/components/checkup_plus/patients/ParametersDetails/MeasurementsCreation/TemperatureCreation.vue";
import BodyCompositionCreation
  from "@/components/checkup_plus/patients/ParametersDetails/MeasurementsCreation/BodyCompositionCreation.vue";
import CholesterolCreation
  from "@/components/checkup_plus/patients/ParametersDetails/MeasurementsCreation/CholesterolCreation.vue";
import AppointmentsTable from "@/components/checkup_plus/patients/ParametersDetails/AppointmentsTable.vue";
import Slider from '@/components/common/Slider'
import moment from "moment";
import LoadingPlaceholder from "@/components/common/LoadingPlaceholder.vue";
import SubmitingPlaceholder from "@/components/common/SubmitingPlaceholder.vue";

const TONAL_TEST_MEASUREMENT_TYPE_ID = 9000
const BLOOD_PRESSURE_MEASUREMENT_TYPE_ID = 2
const OXIMETRY_MEASUREMENT_TYPE_ID = 18
const SPIROMETRY_MEASUREMENT_TYPE_ID = 11
const TEMPERATURE_MEASUREMENT_TYPE_ID = 3
const BODY_COMPOSITION_MEASUREMENT_TYPE_ID = 5
const SARCOPENIA_MEASUREMENT_TYPE_ID = 6001
const FRAILTY_PHENOTYPE_TYPE_ID = 6000
const GLUCOSE_MEASUREMENT_TYPE_ID = 4
const CHOLESTEROL_MEASUREMENT_TYPE_ID = 10000
const MAPA_24_MEASUREMENT_TYPE_ID = 20

export default {
  components: {
    SubmitingPlaceholder,
    LoadingPlaceholder,
    Slider,
    AppointmentsTable,
    CholesterolCreation,
    BodyCompositionCreation,
    TemperatureCreation,
    SpirometryCreation,
    GlucoseCreation,
    OximetryCreation,
    BloodPressureCreation,
    Multiselect,
    Mapa24XmlImporter
  },
  props: {
    patientDetails: {
      type: Object,
      required: true
    },
    selectedMeasurementId: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      showModal: false,
      measurementTypesOptions: [
        {
          id: 2,
          translation: this.$t('dashboard_new_evollu.parameters.blood_pressure'),
          identifier: 'bloodPressure'
        },
        {
          id: 18,
          translation: this.$t('dashboard_new_evollu.parameters.oximetry'),
          identifier: 'oximetry'
        },
        {
          id: 11,
          translation: this.$t('dashboard_new_evollu.parameters.spirometry'),
          identifier: 'spirometry'
        },
        {
          id: 3,
          translation: this.$t('dashboard_new_evollu.parameters.temperature'),
          identifier: 'temperature'
        },
        {
          id: 5,
          translation: this.$t('dashboard_new_evollu.parameters.body_composition'),
          identifier: 'bodyComposition'
        },
        {
          id: 4,
          translation: this.$t('dashboard_new_evollu.parameters.glucose'),
          identifier: 'glucose'
        },
        {
          id: 10000,
          translation: this.$t('dashboard_new_evollu.parameters.cholesterol'),
          identifier: 'cholesterol'
        },
        {
          id: 20,
          translation: this.$t('dashboard_new_evollu.parameters.mapa24'),
          identifier: 'mapa24'
        }
      ],
      measurement: {
        measurementTypeId: null,
        measurementSeries: [],
        measurements: []
      },
      form: {
        checkup: false,
        measurementType: null,
        selectedAppointment: null,
        appointment: {
          start: moment().format('YYYY/MM/DD HH:mm'),
          end: moment().add(30, 'minutes').format('YYYY/MM/DD HH:mm')
        }
      },
      canSubmit: false,
      isSubmiting: false
    }
  },
  mounted() {
    this.showModal = true
  },
  methods: {
    handleSelectedAppointment(selectedAppointment) {
      this.form.selectedAppointment = selectedAppointment
    },
    resetMeasurementObj() {
      this.measurement = {
        measurementTypeId: null,
        measurementSeries: [],
        measurements: []
      }
    },
    handleCancel() {
      this.showModal = false;
      this.$emit('cancel')
    },
    async handleSubmit() {
      this.isSubmiting = true
      let data = {}
      data.measurementSeries = this.measurement.measurementSeries
      if(data.measurementSeries.length && data.measurementSeries.length > 0) {
        data.measurementSeries.forEach(serie => {
          if(serie.code) {
            delete serie.code
          }
        })
      }
      data.measurements = this.measurement.measurements
      data.date = this.measurement.date
      data.idPerson = this.patientDetails.idPerson
      data.automatic = this.measurement.measuresFromBle ? this.measurement.measuresFromBle : false
      data.measurementGroup = {
        idMeasurementGroup: this.form.measurementType.id
      }

      let appointmentId = null
      if(this.form.selectedAppointment !== null) {
        appointmentId = this.form.selectedAppointment.id
      } else {
        //Create the appointment
        try {
          let data = {
            id: null,
            begin: moment(this.form.appointment.start).valueOf(),
            end: moment(this.form.appointment.end).valueOf(),
            patient: {
              idPerson: this.patientDetails.idPerson
            },
            facilityId: this.patientDetails.facilitiesEvollu[0].id,
            createdAt: null,
            createdBy: null,
            updatedAt: null,
            userUpdater: null,
            status: null,
            statusDescription: null,
            measurementAggregate: null
          }
          let createdAppointment = await  OneCareService.postPatientAppointment(data)
          appointmentId = createdAppointment.id
          this.showToast(this.$t('checkup_plus.person.measurements.create.appointments.messages.success'), this.$store.state.successToastOptions)
        } catch (e) {
          this.isSubmiting = false
          console.log("Error creating appointment")
          console.log(e)
          this.showToast(this.$t('checkup_plus.person.measurements.create.appointments.messages.error'), this.$store.state.errorToastOptions)
        }
      }

      if(appointmentId !== null) {
        data.appointment = {
          id: appointmentId
        }
      }

      //console.log(data)
      try {
        const response = await OneCareService.postMeasurements(data)
        this.showToast(this.$t('checkup_plus.person.measurements.create.messages.success'), this.$store.state.successToastOptions)
        this.showModal = false
        this.isSubmiting = false
        setTimeout(() => {
          this.$emit('measurementCreated', data, this.form.measurementType.identifier)
        }, 250)
      } catch(e) {
        console.log(e)
        this.isSubmiting = false
        this.showToast(this.$t('checkup_plus.person.measurements.create.messages.error'), this.$store.state.errorToastOptions)
      }
    }
  },
  computed: {
    isMobile: function () {
      return window.matchMedia(`(max-width: 767px)`).matches || window.matchMedia(`(max-height: 400px)`).matches
    },
    /*canSubmit() {
      return this.measurement.measurementSeries.length > 0
    },*/
  },
  watch: {
    selectedMeasurementId: {
      immediate: true,
      handler (value) {
        if(value !== null) {
          this.form.measurementType = this.measurementTypesOptions.find(mes => mes.id === value)
        }
      }
    },
  }
}
</script>

<style lang="scss">
.multiselect__content-wrapper {
  position: relative !important;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7); /* Semi-transparent white background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999; /* Ensure it appears above the table */
}

.simple-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7); /* Semi-transparent white background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3; /* Ensure it appears above the table */
}
</style>
